export function calculateNextIndex(
  prevIndex: number,
  elementCount: number,
  isRoundRobin?: boolean
): number {
  if (prevIndex < elementCount - 1) {
    return prevIndex + 1
  }
  if (isRoundRobin) {
    return 0
  }
  return prevIndex
}

export function calculatePreviousIndex(
  prevIndex: number,
  elementCount: number,
  isRoundRobin?: boolean
): number {
  if (prevIndex > 0) {
    return prevIndex - 1
  }
  if (isRoundRobin) {
    return elementCount - 1
  }
  return 0
}

export function calculateNextRowIndex(
  prevIndex: number,
  elementCount: number,
  columnCount: number,
  isRoundRobin?: boolean
): number {
  if (prevIndex < elementCount - columnCount) {
    return prevIndex + columnCount
  }
  if (isRoundRobin) {
    return 0
  }
  return prevIndex
}

export function calculatePreviousRowIndex(
  prevIndex: number,
  elementCount: number,
  columnCount: number,
  isRoundRobin?: boolean
): number {
  if (prevIndex >= columnCount) {
    return prevIndex - columnCount
  }
  if (isRoundRobin) {
    return elementCount - 1
  }
  return prevIndex
}
